import type { QueryClient } from '@tanstack/react-query';

import { INVESTOR_ENTRY_QUERY_KEY, type TInvestorEntryResolution } from '@/features/investor-entry/public';

/**
 * `getQueryData`, not a query: an onboard resolve mints a payment session, so a guard that
 * fetched would create one per visit. Absent cache means "go back through boot".
 */
export const readCachedResolution = (queryClient: QueryClient): TInvestorEntryResolution | undefined =>
  queryClient.getQueryData<TInvestorEntryResolution>(INVESTOR_ENTRY_QUERY_KEY);

export const readCachedLoginPan = (queryClient: QueryClient): string | null => {
  const resolution = readCachedResolution(queryClient);
  return resolution?.action === 'login' ? resolution.data.pan : null;
};
